import { UPDATE_BETSTOP } from './fishnet/actionTypes';

function updateBetstop(response) {
  return {
    type: UPDATE_BETSTOP,
    payload: { response },
  };
}

export default updateBetstop;
